export * from './card';
export * from './register';
export * from './confirm';
export * from './personal-information';
export * from './plan';
export * from './coupon';
export * from './carrier';
export * from './port';
export * from './route';
export * from './vessel';
export * from './schedule';
export * from './trip-models/trips';
export * from './trip-models/trip';
export * from './trip-models/leg';
export * from './voyage-models/voyages';
export * from './voyage-models/voyage';



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/index.ts